export default {"src":"/_next/static/media/profile-difficulties.bf2e261c.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};